import { useCallback, useMemo, useRef, useState } from 'react';
export default function useMouseMoveDelay(delay = 5000) {
  const timerRef = useRef();
  const hoverRef = useRef();
  const [moving, setMoving] = useState(false);
  const afterMouseMove = useCallback(() => {
    setMoving(false);
  }, []);
  const onMouseMove = useCallback(evt => {
    setMoving(true);
    clearTimeout(timerRef.current);
    if (evt.target !== hoverRef.current && !hoverRef.current.contains(evt.target)) {
      timerRef.current = setTimeout(afterMouseMove, delay);
    }
  }, [delay, afterMouseMove]);
  return useMemo(() => {
    return {
      onMouseMove,
      hoverRef,
      moving
    };
  }, [onMouseMove, moving]);
}